module.exports = __webpack_public_path__ + "img/gladius-pc.8b5b8410.png";